<template>
  <div class="calculation-panel" v-if="visible">
    <el-dialog class="calculation-panel" :title="title" :visible.sync="visible" @close="closePanel"
               width="1000px" center :close-on-click-modal="false" append-to-body>
      <div class="modal-body">
        <div class="left">
          <div class="modal-calc">
            <el-form>
              <el-form-item class="line-height" label="函数">
                <el-cascader
                  :options="optionalFuntion"
                  :show-all-levels="false" :value="leftPage.value" @change="changeFunctionValue" filterable>
                </el-cascader>
                <el-button class="insert" type="primary" @click="insertFormula">插入</el-button>
                <el-button class="replace" @click="replaceFormula">替换</el-button>
              </el-form-item>
              <el-form-item class="line-height form-item-formula" label="公式">
                <div class="formula" contenteditable
                     @blur="saveCursor" ref='formula'
                     v-focus="true" v-html="htmlContent">
                </div>
              </el-form-item>
              <el-form-item label="描述">
                <div class="describe">
                  {{leftPage.tip}}
                </div>
              </el-form-item>
              <el-form-item label="示列">
                <div class="examples">
                  {{leftPage.example}}
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="right">
          <div class="modal-columns">
            <h4>数据源</h4>
            <div class="columns">
              <el-menu class="el-menu-vertical">
                <div v-for="(table, index) in dataSource" :key="index">
                  <el-submenu :index="index.toString()" v-if="table.columns">
                    <span slot="title" :name="table.name">{{table.type === 'OneToMany' ? '*':''}}{{table.name}}</span>
                    <el-menu-item-group>
                      <el-menu-item v-for="column in table.columns"
                                    :key='column.id'
                                    :index="column.id"
                                    :name="column.name"
                                    :type="column.dataType"
                                    @click='addParam(column.name,column.id,table.relationId,column.dataType,table.name)'>
                        {{column.name}}
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </div>
              </el-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="data-list-btn">
        <el-button type="primary" @click="saveExpression">保存</el-button>
        <el-button @click="closePanel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {calculateMixin} from '../form/components/mixins'
import {getFormula} from '../../globalComponent/calculation/formula.js'

export default {
  mixins: [calculateMixin],
  name: 'calculation-panel',
  props: {
    expression: {
      type: String,
      required: true
    },
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    functionType: {
      type: Array,
      required: false,
      default () {
        return ['simple', 'math', 'text', 'date', 'logic', 'concat']
      }
    },
    title: {
      type: String,
      required: false,
      default: '计算表达式'
    },
    dataSource: {
      type: Array,
      required: false
    },
    calculationType: {
      type: String,
      required: false,
      default: 'java'
    },
    currentColumnId: {
      type: String,
      required: false,
      default: 'currentColumnId'
    }
  },
  data () {
    return {
      visible: false,
      options: getFormula(),
      leftPage: {
        value: [],
        tip: '',
        example: '',
        cacheformula: '',
        cacheRange: ''
      }
    }
  },
  watch: {
    dialogVisible (val) {
      this.visible = val
    }
  },
  mounted () {
    this.leftPage.tip = this.options[0].tip
    this.leftPage.example = this.options[0].example
  },
  computed: {
    htmlContent () {
      let expression = this.expression
      if (expression) {
        let htmlContent = this.expressionToWithCode(expression)
        return htmlContent
      }
    },
    optionalFuntion () {
      let options = this.options
      options.forEach(el => {
        el.disabled = !this.functionType.includes(el.value)
      })
      return options
    },
    getDataSource () {
      return this.dataSource
    }
  },
  methods: {
    // 点击数据列
    addParam (name, id, relationId, type, tableName) {
      if (!this.leftPage.cacheRange) return
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(this.leftPage.cacheRange)
      var html = `&nbsp;<code contenteditable='false' dataId=${id}+${relationId} name=${name} type='${type}'>${tableName}-${name}</code>&nbsp;`
      // 替换选中的内容
      document.execCommand('insertHTML', false, html)
      this.selectParam(this.$refs.formula)
    },

    replaceFormula () {
      this.$confirm('', '您确定要替换吗，替换将清除公式里面的所有内容', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        customClass: 'replaceMessage',
        center: true
      }).then(() => {
        this.$refs.formula.innerHTML = this.leftPage.cacheformula
        this.selectParam(this.$refs.formula)
      }).catch(() => {})
    },

    insertFormula () {
      let sel = window.getSelection()
      // 判断光标是否停在公式的div中
      if (sel.anchorNode === this.leftPage.cacheRange.anchorNode) {
        // 取到选中的元素的索引
        document.execCommand('insertHTML', false, this.leftPage.cacheformula)
        this.selectParam(this.$refs.formula)
      } else {
        this.$message({
          message: '请选择插入的位置'
        })
      }
    },

    // 光标选中第一个param
    selectParam (selector) {
      selector.focus()
      let sel = window.getSelection()
      let range = sel.getRangeAt(0)
      for (let i = 0, length = selector.childNodes.length; i < length; i++) {
        if (selector.childNodes[i].nodeName === '#text') {
          let str = selector.childNodes[i].data
          let arr = str.split('param')
          let num = arr.length - 1
          if (num >= 1) {
            // 选择第一个param为光标范围
            range.setStart(selector.childNodes[i], arr[0].length)
            range.setEnd(selector.childNodes[i], arr[0].length + 5)
          }
        }
      }
    },
    // 公式div的失焦事件
    saveCursor () {
      let sel = window.getSelection()
      if (sel.rangeCount) {
        this.leftPage.cacheRange = sel.getRangeAt(0)
        this.leftPage.cacheRange.anchorNode = sel.anchorNode
        this.leftPage.cacheRange.anchorOffset = sel.anchorOffset
        this.leftPage.cacheRange.focusNode = sel.focusNode
        this.leftPage.cacheRange.focusOffset = sel.focusOffset
      }
    },
    // 选择改变下拉框的
    changeFunctionValue (val) {
      if (val[1]) {
        // 如函数有第二级
        let item = this.options.find(o => o.value === val[0]).children.find(m => m.value === val[1])
        this.leftPage.cacheformula = item.value
        this.leftPage.tip = item.tip
        this.leftPage.example = item.example
      } else {
        this.leftPage.cacheformula = ''
        this.leftPage.tip = this.options[0].tip
        this.leftPage.example = this.options[0].example
      }
    },
    closePanel () {
      this.$emit('close')
      this.$refs.formula.innerHTML = ''
    },

    saveExpression () {
      let formula = this.$refs.formula.innerHTML
      if (formula === '') {
        this.$emit('getExpression', formula)
        this.$emit('close')
        return
      }
      formula = formula.replace(/&gt;/g, '>')
      formula = formula.replace(/&lt;/g, '<')
      // 将code标签全部替换成${},将code中的值提取出来放到${}中
      formula.match(/<code(.+?)<\/code>/g) && formula.match(/<code(.+?)<\/code>/g).map((el) => {
        let dataId = el.match(/dataid="(.+?)"/g).toString()
        let type = el.match(/type="(.+?)"/g).toString()
        let name = el.match(/name="(.+?)"/g).toString()
        let newstr = el.replace(el, '${' + dataId.slice(8, dataId.length - 1) + ',' + name.slice(6, name.length - 1) + ',' + type.slice(6, type.length - 1) + '}')
        formula = formula.replace(el, newstr)
      })
      let handleFormula = formula.replace(/&nbsp;/g, '')
      if (handleFormula.match(/\$\{(.*?)\}/)) {
        if (this.calculationType === 'java' && !this.validateExpression(handleFormula)) {
          return
        }
      }
      // 调用接口进行校验公式的正确性
      this.$axios.post(`/report-api/report/calculation/verification`, {formula: handleFormula})
        .then(res => {
          this.$emit('getExpression', handleFormula)
          this.$emit('close')
          // 重置
          this.leftPage = {
            value: [],
            tip: this.options[0].tip,
            example: this.options[0].example,
            cacheformula: '',
            cacheRange: ''
          }
        })
    },
    validateExpression (expression) {
      let flag = true
      let cancatFuns = []
      // todo: 获取聚合函数的方式需要修改
      // 获取所有的聚合函数
      this.options.find(m => m.value === 'concat').children.forEach(m => {
        cancatFuns.push(m.value.substring(0, m.value.indexOf('(')))
      })
      expression = expression.replace(/\s/g, '')
      let regs = new RegExp(`(${cancatFuns.join('|')})\\((.+?)\\)`, 'gi')
      let oneToMaycolumns = []
      expression.match(regs) && expression.match(regs).map(m => {
        if (m.match(/\$\{(.*?)\}/)) {
          m.match(/\$\{(.*?)\}/g).forEach(n => {
            oneToMaycolumns.push({
              'functionName': m.substring(0, m.indexOf('(')),
              'columnId': n.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[0],
              'relationId': n.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[1]
            })
          })
        }
      })
      let oneToOneColumns = []
      expression.match(/\$\{(.*?)\}/g).map(m => {
        let columnId = m.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[0]
        let relationId = m.match(/\$\{(.*?)\}/)[1].split(',')[0].split('+')[1]
        let temp = oneToMaycolumns.find(n => n.columnId === columnId && n.relationId === relationId)
        if (!temp) {
          oneToOneColumns.push({
            columnId,
            relationId
          })
        }
      })
      for (let i = 0; i < oneToOneColumns.length; i++) {
        let table = this.getTableByColumnId(oneToOneColumns[i])
        if (table.type !== 'OneToOne') {
          let column = table.columns.find(m => m.id === oneToOneColumns[i].columnId)
          flag = false
          this.$message.error(`参数 ${column.name} 需要配合聚合函数使用`)
          break
        }
      }
      for (let i = 0; i < oneToMaycolumns.length; i++) {
        let table = this.getTableByColumnId(oneToMaycolumns[i])
        if (table.type !== 'OneToMany') {
          flag = false
          this.$message.error(`函数 ${oneToMaycolumns[i].functionName} 需要选择子表信息(带有 * 号的为子表)`)
          break
        }
      }
      return flag
    },

    getTableByColumnId (column) {
      return this.dataSource.find(m => {
        if (m.columns && m.columns.find(n => n.id === column.columnId)) {
          return m
        }
      })
    }
  }
}

</script>
<style lang="scss">
  .calculation-panel {
    .el-dialog {
      .el-dialog__header {
        border-bottom: 1px solid #ddd;
        height: 40px;
        padding: 0px;
        background-color: #eeeeee;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;

        line-height: 40px;
        .el-dialog__title {
          font-size: 14px;
        }
        .el-dialog__headerbtn {
          top: 5px;
          right: 5px;
        }
      }
      .el-dialog__body {
        padding: 0;
        padding-top: 20px;
        .modal-body {
          height: 100%;
          &::after {
            content: "";
            display: block;
            clear: both;
          }
          .el-row {
            margin: 0;
          }
          .left {
            width: 500px;
            height: 100%;
            float: left;
            margin-left: 75px;
            margin-right: 29px;
            form {
              > .line-height {
                margin-bottom: 22px;
                height: 28px;
                .el-form-item__content {
                  height: 28px;
                  line-height: 28px;
                }
              }
              .form-item-formula {
                .el-form-item__content {
                  line-height: 26px;
                }
              }
              .el-form-item__content {
                margin-left: 44px;
              }
              button.el-button {
                width: 55px;
                height: 28px;
                padding-top: 5px;
              }
              .replace {
                margin-left: -5px;
                -webkit-border-radius: 0 4px 4px 0;
                -moz-border-radius: 0 4px 4px 0;
                border-radius: 0 4px 4px 0;
                border-left: 0;
                &:hover, &:active, &:focus {
                  background-color: #fff;
                  color: #606266;
                  border-color: #DCDFE6;
                }
                span {
                  margin-left: -2px;
                }
              }
              .insert {
                border-right: 0;
                -webkit-border-radius: 4px 0 0 4px;
                -moz-border-radius: 4px 0 0 4px;
                border-radius: 4px 0 0 4px;
              }
              .describe {
                width: 456px;
                height: 141px;
                border: 1px solid #e4e7ed;
                border-radius: 4px;
              }
              .examples {
                width: 456px;
                height: 92px;
                border: 1px solid #e4e7ed;
                border-radius: 4px;
              }
            }
          }
          .right {
            width: 290px;
            height: 100%;
            float: right;
            margin-right: 75px;
            margin-left: 29px;
          }
        }
        .modal-calc {
          .el-cascader {
            width: 342px;
            line-height: 28px;
            .el-input__inner {
              height: 28px;
              line-height: 28px;
            }
          }
          .formula {
            outline: none;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            padding: 0 10px;
            height: 29px;
            overflow: auto;

            code {
              padding: 2px 4px;
              font-size: 90%;
              color: #c7254e;
              background-color: #f9f2f4;
              border-radius: 4px;
            }
          }

          .info {
            color: rgb(49, 112, 143);
            background-color: rgb(217, 237, 247);
            border: 1px solid rgb(188, 232, 241);
            padding: 15px;
            border-radius: 4px;
            height: 134px;
            overflow: auto;
          }
          .example {
            // 允许文字被鼠标选中
            -moz-user-select: text;
            -o-user-select: text;
            -webkit-user-select: text;
            -ms-user-select: text;
            user-select: text;
          }
        }

        .modal-columns {
          h4 {
            font-size: 14px;
          }
          .columns {
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow-y: auto;
            max-height: 334px;
            min-height: 334px;
            .el-menu-item-group__title {
              padding: 0;
            }
            .el-menu > div {
              border-bottom: 1px solid #ddd;
              .el-submenu__title {
                width: 100%;
                height: 34px;
                line-height: 34px;
                color: #62b2f3;
                i {
                  color: #62b2f3;
                }
              }
              .el-menu-item:hover {
                outline: 0;
                background-color: #b7e0ff;
              }
              .el-menu-item {
                width: 100%;
                height: 24px;
                line-height: 24px;
              }
            }
          }
        }
      }
      .data-list-btn {
        background: #fff;
        padding: 22px 10px 32px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        align-items: center;
        text-align: center;
        button {
          width: 72px;
        }
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/calculation-panel.vue